import { useDispatch, useSelector } from 'react-redux'
import { openChat } from '@slices/uiSlice'
import { soundManager } from '@core/audio/sounds/soundManager'
import { INTERNAL_CONSTANTS } from '@constants/internalConstants'
import { ChatSVG } from '@media/svgs'

/**
 * Header chat button — mobile/tablet only. Desktop opens chat from the
 * activity-panel tab, so the icon is hidden there. Gated by the `chat` feature
 * toggle.
 */
const ChatModule = () => {
  const dispatch = useDispatch()
  const { chat } = useSelector((state) => state.configurations.featureToggles)
  const isDesktop = useSelector((state) => state.layout.mode) === INTERNAL_CONSTANTS.DEVICES.DESKTOP

  if (!chat || isDesktop) return null

  const handleOpen = () => {
    soundManager.play('CLICK')
    dispatch(openChat())
  }

  return (
    <div className="standard-normal-chat-module-container">
      <button
        type="button"
        className="standard-normal-chat-icon-container"
        onClick={handleOpen}
        aria-label="Open chat"
      >
        <ChatSVG width={25} height={25} />
      </button>
    </div>
  )
}

export default ChatModule
